import { render, staticRenderFns } from "./product-score-overview.component.vue?vue&type=template&id=6fdd65d6&scoped=true"
import script from "./product-score-overview.component.vue?vue&type=script&lang=ts"
export * from "./product-score-overview.component.vue?vue&type=script&lang=ts"
import style0 from "./product-score-overview.component.vue?vue&type=style&index=0&id=6fdd65d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd65d6",
  null
  
)

export default component.exports